import { render, staticRenderFns } from "./BtnInserirComissionamento.vue?vue&type=template&id=57e6d617"
import script from "./BtnInserirComissionamento.vue?vue&type=script&lang=js"
export * from "./BtnInserirComissionamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports